<div class="envios-wrapper">
  <div class="card glass envios-card" *ngIf="!error; else notCitys">
    <div class="card-header">
      <span class="mdi mdi-map-marker-radius"></span>
      <h3>Datos de Entrega</h3>
    </div>

    <div class="form-content">
      <div class="row row-main">
        <div class="field-group city-selector">
          <label class="label-vanguard">Ciudad</label>
          <div class="selector-wrapper">
            <selector-generico *ngFor="let ciudad of ciudades" (onSelect)="ciudadSeleccionada($event)" [mode]="'selector'"
              [catego]="ciudad" [defaultSelect]="ciudadElegida"></selector-generico>
          </div>
        </div>

        <div class="field-group city-info" *ngIf="mostrarCosto">
          <div class="info-item">
            <span class="info-label">Costo de Envío:</span>
            <span class="info-value highlighted" [class.free]="costo===0">
              {{costo > 0 ? (costo | currency) : 'Envío Gratis'}}
            </span>
          </div>
          <div class="info-item">
            <span class="info-label">Código Postal:</span>
            <span class="info-value">{{codigoPostal}}</span>
          </div>
        </div>
      </div>

        <div class="vanguard-form" [formGroup]="formEnvio">
          <div class="form-grid">
            <div class="field-group">
              <label class="label-vanguard">Calle</label>
              <input type="text" class="input-vanguard" placeholder="Ingrese su calle de residencia"
                [formControlName]="'calle'" (input)="datosEnvio()">
            </div>
            <div class="field-group">
              <label class="label-vanguard">Número</label>
              <input type="text" class="input-vanguard" placeholder="Ingrese su número/altura"
                [formControlName]="'numero'" (input)="datosEnvio()">
            </div>
          </div>
          <div class="form-row-single">
            <div class="field-group">
              <label class="label-vanguard">Barrio</label>
              <input type="text" class="input-vanguard" placeholder="Ingrese su barrio de residencia"
                [formControlName]="'barrio'" (input)="datosEnvio()">
            </div>
          </div>
        </div>
    </div>

    <!-- MAPA DE ENTREGA -->
    <div class="mapa-section" *ngIf="mapVisible">
      <div class="mapa-header">
        <span class="mdi mdi-map-search"></span>
        <h4>Ubicar dirección de entrega</h4>
      </div>

      <div class="mapa-instrucciones">
        <span class="mdi mdi-information-outline"></span>
        Hacé clic en el mapa para colocar el pin, o buscá tu dirección automáticamente. También podés arrastrar el pin para ajustar la ubicación.
        <span *ngIf="cargandoZona"> Cargando zona de entrega...</span>
      </div>

      <div class="mapa-zona-aviso" *ngIf="!cargandoZona && zonaCoords?.length >= 3">
        <span class="mdi mdi-map-marker-radius"></span>
        La zona sombreada en el mapa indica el área de entrega disponible para esta ciudad.
      </div>

      <button class="btn-buscar-dir" (click)="buscarDireccion()" [disabled]="buscandoDireccion">
        <span class="mdi" [class.mdi-magnify]="!buscandoDireccion" [class.mdi-loading]="buscandoDireccion" [class.mdi-spin]="buscandoDireccion"></span>
        {{ buscandoDireccion ? 'Buscando...' : 'Buscar dirección en el mapa' }}
      </button>

      <div id="mapa-entrega" class="mapa-contenedor"></div>

      <div class="mapa-error-zona" *ngIf="fueraDeZona">
        <span class="mdi mdi-map-marker-off"></span>
        La ubicación seleccionada está fuera de la zona de entrega para esta ciudad. Por favor elegí un punto dentro del área sombreada.
      </div>

      <div class="mapa-coordenadas" *ngIf="pinLatitud !== null">
        <span class="mdi mdi-map-marker-check"></span>
        Pin ubicado: {{ pinLatitud | number:'1.5-5' }}, {{ pinLongitud | number:'1.5-5' }}
      </div>
    </div>

  </div>
</div>

<ng-template #notCitys>
  <div style="font-size: 20px;">
    No hay ciudades disponibles.
  </div>
</ng-template>
